<template>
  <div :class="$style.icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17639 17639"
    >
      <g>
        <path
          :class="$style.st0"
          d="M9596 3634l0 10265 -6103 -1058 0 -8149 6103 -1058zm290 1185l4053 0c224,0 267,44 267,267l0 7360c0,223 -43,267 -267,267l-4053 0 0 -694 1547 0 0 -1066 -1547 0 0 -320 1547 0 0 -1067 -1547 0 0 -320 1547 0 0 -1067 -1547 0 0 -320 1547 0 0 -1066 -1547 0 0 -320 1547 0 0 -1067 -1547 0 0 -587zm-7803 10774l13474 0 2 -13476 -13478 0 2 13476z"
        />
        <polygon
          :class="$style.st0"
          points="7129,6861 6573,8133 6141,6938 5446,6969 6136,8710 5359,10413 6042,10464 6590,9239 7100,10535 7886,10578 7034,8703 7849,6809 "
        />
        <polygon
          :class="$style.st0"
          points="11753,12019 13513,12019 13513,10953 11753,10953 "
        />
        <polygon
          :class="$style.st0"
          points="11753,10633 13513,10633 13513,9566 11753,9566 "
        />
        <polygon
          :class="$style.st0"
          points="11753,9246 13513,9246 13513,8179 11753,8179 "
        />
        <polygon
          :class="$style.st0"
          points="11753,6473 13513,6473 13513,5406 11753,5406 "
        />
        <polygon
          :class="$style.st0"
          points="11753,7859 13513,7859 13513,6793 11753,6793 "
        />
      </g>
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'UploadBulkMetadataIcon'
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/fonts';
@import 'mpl-css/lib/assets/global/functions/index';
.st0{fill: #1E7145}
.icon {
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}
</style>
